<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <div class="left_tit">
        招商、运营、服务数据共享，打破信息孤岛，实现统一管理
      </div>
      <ul class="left_desc">
        <li>各平台数据实时共享，消除信息壁垒，支持各部门协同作业。管理人员通过仪表盘总览，实时掌握园区动态，科学决策，全面提升园区管理水平与服务质量，为企业营造优质发展环境。</li>
      </ul>
      <div class="left_card">
        <div class="card_item" v-for="(item, index) in cardList" :key="index">
          <i class="iconfont">{{item.icon}}</i>
          <span class="item_txt">{{ item.txt }}</span>
        </div>
      </div>
    </el-col>
    <el-col class="one_right">
      <img src="@/assets/img/right1.png" alt="">
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          icon: '🌍',
          txt: '租控总览',
        },
        {
          icon: '📜',
          txt: '合同管理',
        },
        {
          icon: '💼',
          txt: '招商项目',
        },
        {
          icon: '🧰',
          txt: '物业管理',
        },
        {
          icon: '💎',
          txt: '企服中心',
        },
        {
          icon: '💹',
          txt: ' 费用管理',
        },
        {
          icon: '💳',
          txt: '财务管理',
        },
        {
          icon: '🏢',
          txt: '资源管理',
        },
        {
          icon: '🤖',
          txt: '用户管理',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.core_one_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  margin-bottom: 30px;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
  .one_left {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      color: #717171;
      padding: 10px 40px 20px 40px;
      li {
        line-height: 25PX;
      }
      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    .left_card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 25px;
      margin-right: 80px;
      @media screen and (max-width: 768px) {
        margin: 0;
      }
      .card_item {
        box-sizing: border-box;
        width: 30%;
        height: 50px;
        background: #fff;
        box-shadow: 0 -0.0625rem 0.4375rem 0 silver,
          0 0 0.75rem 0 rgb(0 0 0 / 10%);
        display: flex;
        align-items: center;
        color: #0991d3;
        padding: 0 20px;
        // cursor: pointer;
        @media screen and (max-width: 768px) {
          height: 50PX;
        }
        i{
          font-size: 1.3rem;
        }
        &:nth-child(n + 4) {
          margin-top: 30px;
          @media screen and (max-width: 768px) {
            margin-top: 16PX;
          }
        }
        &:hover .item_txt {
          letter-spacing: 4px;
        }
        .item_txt {
          width: 100%;
          font-weight: bold;
          font-size: 17px;
          margin-left: 10px;
          transition: all 1s;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }
  }

  .one_right {
    width: 20%;
    height: 100%;
    @media screen and (max-width: 768px) {
      width: 70%;
      margin-top: 20PX;
    }
    img{
      width: 100%;
      margin-top: 40px;
    }
  }
}
</style>